import React from "react";
import {useTranslation} from "react-i18next";

const PaymentBusinessAdSection = ()=>{
    const {t}=useTranslation('paymentpage')
    return(
        <section className="payment-business-ad">
            <div className="section-container">
                <div className="payment-business-ad-section">
            <div className="left-payment-business-ad-section">
                <div className="left-payment-business-ad-section-content">
                    {t('left-payment-business-ad-section.line1')}
                    <p>{t('left-payment-business-ad-section.line2')}</p>
                </div>
            </div>
            <div className="right-payment-business-ad-section">
                <div className="right-payment-business-ad-section-content">
                    <div className="right-payment-business-ad-section-content-box1">
                    {t('right-payment-business-ad-section-box1')}
                    </div>
                    <div className="right-payment-business-ad-section-content-box2">
                    {t('right-payment-business-ad-section-box2')}
                    </div>
                    <div className="right-payment-business-ad-section-content-box3">
                    {t('right-payment-business-ad-section-box3')}
                    </div>
                    <div className="right-payment-business-ad-section-content-box4">
                    {t('right-payment-business-ad-section-box4')}
                    </div>
                    </div>
                </div>
            </div>
         </div>
    </section> 
    )
   

}

export default PaymentBusinessAdSection;